import { getModalityTypeById, validateTokenQueryString } from '../../../utils';
import CoreServices from '../../core/services/CoreServices';
import AccountStore from '../../account/store/AccountStore';
import FlowStore from '../../core/store/FlowStore';
import QuoteStore from '../store/QuoteStore';

export function getLeadData(token) {
  return CoreServices.getInstance().get(
    `${process.env.REACT_APP_BFF_SERVICE}/leads?token=${token}`
  );
}

export function updateLead(leadId, data) {
  return CoreServices.getInstance().patch(`${process.env.REACT_APP_BFF_SERVICE}/leads/${leadId}`, {
    ...data,
  });
}

export function buildLeadModel(leadData) {
  const { cnpj, razaoSocial, novoLead, modalidade, modalidadeId } = leadData;
  const { token } = QuoteStore.Lead;

  AccountStore.policyholder.cgcCnpj = cnpj;
  AccountStore.policyholder.razaoSocial = razaoSocial;

  QuoteStore.Lead = { ...leadData, token };
  FlowStore.showAllModalities = true;
  FlowStore.optimized = cnpj !== null;

  if (modalidade === 'Licitante' || modalidade === 'Performance LP') {
    saveLeadDataToLocalStorage(leadData);
  }
  if (modalidade !== '') {
    startFlow(modalidadeId);
  }

  CoreServices.triggerLeadDataLayer(novoLead);
}

export function saveLeadDataToLocalStorage(data) {
  if (!shouldSaveLeadData()) return;
  localStorage.setItem('leadData', JSON.stringify(data));
}

export function shouldSaveLeadData() {
  const shouldSkip = sessionStorage?.getItem('skipLeadData') || false;
  return !shouldSkip;
}

export function startFlow(modalidadeId) {
  QuoteStore.ModalityId = modalidadeId;
  FlowStore.flowStarted = true;
  FlowStore.showAllModalities = false;
  FlowStore.modality = getModalityTypeById(modalidadeId);
}

export function shouldFetchLead(tokenName = 't') {
  const { policyholder } = AccountStore;
  if (!policyholder.cgcCnpj && validateTokenQueryString(tokenName)) return true;

  return false;
}
